import { createApi } from '@reduxjs/toolkit/query/react';

import { lubavAppBaseQuery } from '../baseQuery';

type BlueprintAspirationsCategoriesRequest = Readonly<{
  response_set_id: string;
}>;

export type BlueprintAspirationsCategories = Readonly<{
  id: number;
  lifestyle_and_home: string;
  work_settings: string;
  sources_of_meaning: string;
  locations_and_options: string;
  career_attributes: string;
  activities: string;
  family_and_caregiving: string;
  building_wealth: string;
  career_user_response_set_id: string;
  created_at: string;
  updated_at: string;
}>;

export const blueprintLubavApi = createApi({
  reducerPath: 'blueprintLubavApi',
  baseQuery: lubavAppBaseQuery,
  tagTypes: ['AspirationsCategories'],
  keepUnusedDataFor: 60 * 60 * 24 * 7, // Cache for 7 days (in seconds)
  endpoints: (build) => ({
    fetchAspirationsCategories: build.query<
      BlueprintAspirationsCategories,
      BlueprintAspirationsCategoriesRequest
    >({
      query: (body) => ({
        url: '/api/generate/blueprint/get-aspirations-categories',
        method: 'POST',
        body,
      }),
      providesTags: ['AspirationsCategories'],
    }),
  }),
});

export const { useFetchAspirationsCategoriesQuery } = blueprintLubavApi;
